module.exports = __webpack_public_path__ + "img/book.71d2ffcb.svg";